<template>
  <Pie
    :options="{
      plugins: {
        tooltip: {
          enabled: false
        },

      },
      hover: {
        mode: null
      }
    }"
    :data="{
      chartOptions: {
        responsive: true,
        tooltip: false
      },
      labels: ['Quantità vincenti', 'Quantità da rilanciare'],
      datasets: [
        {
          backgroundColor: ['rgb(34,197,94)', 'rgb(197,34,94)'],
          data: [winning, biddable]
        }
      ]
    }"
  />
</template>

<script setup>
import { Pie } from 'vue-chartjs'

defineProps({
    winning: {
        type: Number,
        required: true
    },
    biddable: {
        type: Number,
        required: true
    }
})
</script>